import { t } from '@lingui/core/macro'
import { useMemo } from 'react'
import Col from 'react-bootstrap/Col'
import MultiSelect from '~/components/multi_select'
import Select from '~/components/select'
import DashboardFilters from '~/dashboard/dashboard_filters'
import useChartFilters from '~/hooks/use_chart_filters'
import {
  awsAccountsChartOptionPath,
  awsRecordTypesChartOptionPath,
  awsRegionsChartOptionPath,
  awsServicesChartOptionPath,
} from '~/routes'
import { awsChargeTypes } from '~/utils/aws'

export default function AWSDashboardFiltersUsageTypeGroup({ organizationId: orgId, setChartParams }) {
  const [onApply, onReset, onChange, params] = useChartFilters(setChartParams)

  // memoize URLs to prevent rerenders
  const accountsUrl = useMemo(() => awsAccountsChartOptionPath(orgId), [orgId])
  const recordTypesUrl = useMemo(() => awsRecordTypesChartOptionPath(orgId), [orgId])
  const regionsUrl = useMemo(() => awsRegionsChartOptionPath(orgId), [orgId])
  const servicesUrl = useMemo(() => awsServicesChartOptionPath(orgId), [orgId])

  return (
    <DashboardFilters onApply={onApply} onReset={onReset}>
      <Col>
        <MultiSelect
          label={t`Account`}
          name='awsAccountIds'
          onChange={onChange}
          url={accountsUrl}
          selected={params.awsAccountIds}
        />
      </Col>
      <Col>
        <MultiSelect
          label={t`Service`}
          name='awsServices'
          onChange={onChange}
          url={servicesUrl}
          params={params}
          selected={params.awsServices}
        />
      </Col>
      <Col>
        <MultiSelect
          label={t`Record type`}
          name='awsRecordTypes'
          onChange={onChange}
          url={recordTypesUrl}
          params={params}
          selected={params.awsRecordTypes}
        />
      </Col>
      <Col>
        <MultiSelect
          label={t`Region`}
          name='awsRegions'
          onChange={onChange}
          url={regionsUrl}
          params={params}
          selected={params.awsRegions}
        />
      </Col>
      <Col>
        <Select
          label={t`Charge type`}
          name='awsChargeType'
          onChange={onChange}
          options={awsChargeTypes()}
          selected={params.awsChargeType}
        />
      </Col>
    </DashboardFilters>
  )
}
